module.exports = __webpack_public_path__ + "img/pc-sort.50d86d00.svg";